<template>
  <div class="c-box">
    <div class="box-inner">
      <!-- [20241206] 약관수정 -->
      <div class="c-terms">
        <strong class="subject">제 1 장 총칙</strong>
        <p class="text">제1조 &lt;목적&gt;</p>
        <p class="text">
          본 약관은 (주)<em class="is-highlight"
            >노루페인트 페인트 프로(paintpro.noroopaint.com)</em
          >
          회원이 <em class="is-highlight">(주)노루페인트</em> 에서 제공하는
          On-Line서비스를 이용함에 있어 페인트 프로 회원 및 (주)노루페인트의
          제반 권리, 의무 및 관련 절차 등을 규정하는데 그 목적이 있습니다.
        </p>
        <p class="text">제2조 &lt;약관동의&gt;</p>
        <p class="text">
          (주)노루페인트에서 운영하는 페인트 프로 홈페이지는 이 약관에 동의한
          이용자들에게 무료로 제공되는 서비스 이며, 이용자가 등록절차를 거쳐서
          "등록하기" 단추를 누르면 이 약관에 동의하는 것으로 간주됩니다.
        </p>
        <p class="text">제3조 &lt;약관개정&gt;</p>
        <ul class="list">
          <li>
            ① 본 약관은 수시로 개정될 수 있으며 약관을 개정하고자 할 경우
            (주)노루페인트는 개정된 약관을 적용하고자 하는 날(이하 "효력
            발생일")로부터 30일 이전에 약관이 개정된다는 사실과 개정된 내용 등을
            아래에 규정된 방법 중 1가지의 방법으로 회원에게 고지하여 드립니다.
            <ul class="child-list">
              <li>ⅰ) e-mail 발송</li>
              <li>
                ⅱ)
                <em class="is-highlight">페인트 프로</em> 홈페이지 내 게시
              </li>
            </ul>
          </li>
          <li>
            ② (주)노루페인트가 e-mail 발송의 방법으로 본 약관이 개정된 사실 및
            개정된 내용을 회원에게 고지하는 경우에는 회원이 (주)노루페인트에 기
            제공한 e-mail address로 통보합니다.
          </li>
          <li>
            ③ 본 조의 규정에 의하여 개정된 약관(이하 "개정약관")은 원칙적으로 그
            효력 발생일로부터 장래를 향하여 유효합니다.
          </li>
          <li>
            ④ 본 약관의 개정과 관련하여 이의가 있는 회원은 회원탈퇴를 할 수
            있습니다. 단, 이의가 있음에도 불구하고 본 조 제①항 내지 제②항에
            정해진 바에 따른 (주)노루페인트의 고지가 있은 후 30일 이내에
            회원탈퇴를 하지 않은 회원은 개정 약관에 동의한 것으로 봅니다.
          </li>
          <li>
            ⑤ 본 조의 통지방법 및 통지의 효력은 본 약관의 각 조항에서 규정하는
            개별적인 또는 전체적인 통지의 경우에 이를 준용한다.
          </li>
        </ul>
        <strong class="subject">제 2 장 회원가입</strong>
        <p class="text">제4조 &lt;회원가입&gt;</p>
        <ul class="list">
          <li>
            ① 회원으로 가입하고자 하는 고객은 (주)노루페인트가 정한
            회원가입신청서에 정해진 사항을 기입한 후 본 약관과 아래 개인정보의
            수집, 제공 및 활용에 관한 동의서에 동의함으로써 회원가입을
            신청합니다.
            <ul class="child-list">
              <li>
                - 개인신용정보의 제공 및 활용동의서<br />
                본인은 (주)노루페인트 이용약관에 동의하며, 본 신청서에 기재된
                내용이 사실과 일치함을 확인합니다. 본인은 본 신청서에 기재된
                본인의 개인정보, 기타 본 서비스 이용에 관한 일체의 거래정보를
                본인에 대한 일체의 마케팅 활동 등의 업무목적으로 귀사가 직접
                사용하는 것에 동의합니다. 또한 본인은 통신판매업을 영위하고 있는
                (주)노루페인트가 본인에 대하여 금융, 건강, 교육 등의 상품과
                서비스 상품을 홍보 및 판매할 수 있도록, 귀사가 본 신청서에
                기재된 본인의 개인정보를 (주)노루페인트에게 제공하는 것에
                동의하고, 아울러 귀사가 위와 같은 목적으로 위의 정보를 수집하는
                것에 동의합니다.
              </li>
            </ul>
          </li>
          <li>
            ② 회원은 회원자격을 타인에게 양도하거나 대여 또는 담보의 목적으로
            이용할 수 없습니다.
          </li>
        </ul>
        <p class="text">제5조 &lt;회원탈퇴 및 자격상실&gt;</p>
        <ul class="list">
          <li>
            ① 회원은 언제든지 서면, e-mail, 전화 기타 (주)노루페인트가 정하는
            방법으로 회원탈퇴를 요청할 수 있으며, (주)노루페인트는 회원의 요청에
            따라 조속히 회원탈퇴에 필요한 제반 절차를 수행합니다.
          </li>
          <li>
            ② 회원이 다음 각 호의 사유에 해당하는 경우, (주)노루페인트는 당해
            회원에 대한 통보로서 회원의 자격을 상실 시킬 수 있습니다. 단, ⅲ)호의
            경우에는 별도의 통보 없이 당연히 자격이 상실됩니다.
            <ul class="child-list">
              <li>ⅰ) 회원가입 신청시에 허위의 내용을 등록한 경우</li>
              <li>
                ⅱ) 당사의 승인을 받지 아니한 광고, 판촉물, 정크메일, 스팸 등,
                조직 기타 다른 형태의 권유를 게시, 게재, 전자메일 또는 기타의
                방법으로 전송하는 경우
              </li>
              <li>ⅲ) 회원이 사망한 경우</li>
              <li>
                ⅳ) (주)<em class="is-highlight">노루페인트 페인트 프로</em>를
                이용하여 구입한 재화, 용역 등의 대금, 기타 이용과 관련하여
                회원이 부담하는 채무를 기일에 지급하지 않는 경우
              </li>
              <li>
                ⅴ) 다른 회원의 (주)<em class="is-highlight"
                  >노루페인트 페인트 프로</em
                >
                이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는
                경우
              </li>
              <li>
                ⅵ) (주)<em class="is-highlight">노루페인트 페인트 프로를</em>
                이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를
                하는 경우
              </li>
              <li>ⅶ) 기타 본 약관에 규정된 회원의 의무를 위반한 경우</li>
            </ul>
          </li>
          <li>
            ③ 본 조 제①항에 의한 회원탈퇴 또는 제②항에 의한 회원자격상실이
            확정되는 시점은 아래와 같습니다.
            <ul class="child-list">
              <li>
                ⅰ) 회원탈퇴 요청일 또는 회원자격상실 통보일에 회원탈퇴 또는
                자격상실이 확정됩니다.
              </li>
              <li>
                ⅱ) 사망으로 인한 자격상실의 경우에는 회원 사망일에 자격상실이
                확정됩니다.
              </li>
            </ul>
          </li>
        </ul>
        <strong class="subject">제 3 장 개인정보 보호</strong>
        <p class="text">제6조 &lt;개인정보 수집&gt;</p>
        <ul class="list">
          <li>
            ① (주)노루페인트는 회원이 가입신청을 할 때뿐만 아니라 당사가 정한
            채널을 통해 수시로 회원의 개인정보를 수집할 수 있습니다. 이는
            회원에게 보다 최적화된 형태로 도료서비스를 제공하고, 고객지향적인
            마케팅을 수행하기 위함입니다.
          </li>
          <li>
            ② (주)노루페인트가 회원으로부터 수집하는 개인정보는 회원의 사업자
            등록번호, 특약점명, 대표자명, 전자우편 주소, 대리점전화번호,
            휴대전화번호 등 회원 가입신청서상 기재된 정보입니다.
          </li>
          <li>
            ③ 회원은 (주)노루페인트에 제공한 개인정보와 관련하여 변경사항이 있는
            경우에는 지체 없이 (주)노루페인트에 그 변경사실을 통지하여야 하며,
            이를 위반하여 발생한 일체의 손해에 대하여 (주)노루페인트는 어떠한
            책임도 지지 않습니다.
          </li>
        </ul>
        <p class="text">제7조 &lt;개인정보 이용과 제공&gt;</p>
        <ul class="list">
          <li>
            ① (주)노루페인트는 회원에게 최적화된 서비스를 제공하기 위한 목적으로
            고객지향적인 마케팅 수행 및 회원이 '개인정보의 수집, 제공 및
            활용동의서'에 기재된 목적 범위 내에서만 수집된 개인정보를
            활용합니다.
          </li>
          <li>
            ② (주)노루페인트는 수집한 개인정보를 당해 회원의 동의 없이 전항에
            기재된 목적 범위를 넘어선 용도로 이용하거나 '개인정보의 수집, 제공
            및 활용 동의서'에 기재된 자 이외의 제3자에게 제공할 수 없습니다.
            다만, 다음의 경우에는 예외로 합니다.
            <ul class="child-list">
              <li>
                ⅰ) 배송업무상 배송업체에게 배송에 필요한 최소한의 회원의
                정보(성명, 주소, 전화번호)를 알려주는 경우
              </li>
              <li>
                ⅱ) 통계작성 연구 또는 마케팅 활동 등을 위하여 필요한 경우로서
                특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
              </li>
            </ul>
          </li>
        </ul>
        <p class="text">제8조 &lt;개인정보 보유 및 이용기간&gt;</p>
        <p class="text">
          (주)노루페인트는 수집된 회원의 개인정보를 회원이 회원자격을 유지하고
          있을 때까지만 보유하고 이용할 수 있습니다. 만약, 회원이 탈퇴하거나
          자격을 상실할 경우 (주)노루페인트는 회원의 별도 요청이 없을 경우라도
          수집된 회원정보를 삭제 및 파기하기로 합니다.
        </p>
        <p class="text">제9조 &lt;개인정보처리의 위탁&gt;</p>
        <p class="text">
          (주)노루페인트는 수집된 개인정보의 취급 및 관리 등의 업무(이하
          "업무")를 스스로 수행함을 원칙으로 하나, 필요한 경우 업무의 일부 또는
          전부를 (주)노루페인트가 선정한 회사에 위탁할 수 있습니다.
        </p>
        <p class="text">제10조 &lt;개인정보관리&gt;</p>
        <ul class="list">
          <li>
            ① (주)노루페인트는 수집된 회원의 개인정보 관리를 위해
            개인정보관리책임자를 지정하여 그 성명, 소속부서, 직위 및 전화번호,
            e-mail address를 본 계약 제4조 제①항에 규정된 통지방법을 준용하여
            회원에게 알려드립니다.
          </li>
          <li>
            ② (주)노루페인트는 회원이 안심하고 (주)노루페인트 페인트 프로를
            이용할 수 있도록 회원의 개인정보 보호를 위한 보안시스템을 갖추도록
            노력합니다.
          </li>
        </ul>
        <strong class="subject"
          >제 5 장 (주)노루페인트
          <em class="is-highlight">페인트 프로</em> 홈페이지</strong
        >
        <p class="text">
          제11조 &lt;(주)노루페인트
          <em class="is-highlight">페인트 프로</em> 홈페이지&gt;
        </p>
        <ul class="list">
          <li>
            ① (주)노루페인트는 대리점 회원에 대한 최고의 도료 서비스를 제공하기
            위하여 (주)<em class="is-highlight">노루페인트 페인트 프로</em>
            홈페이지를 운영하며, 본 약관 제11조는 회원이
            <em class="is-highlight">(주)노루페인트 페인트 프로에서</em>
            제공하는 각종 서비스(이하 "홈페이지 서비스")를 이용함에 있어 필요한
            사항을 규정합니다.
          </li>
          <li>
            ② (주)노루페인트는 (주)노루페인트
            <em class="is-highlight">페인트 프로</em> 홈페이지 운영과 관련하여
            관계 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지
            않으며, 이 약관이 정하는 바에 따라 지속적이고 안정적으로 재화 및
            용역을 제공하는 데 최선을 다합니다.
          </li>
        </ul>
        <p class="text">제12조 &lt;홈페이지 서비스의 내용 및 변경&gt;</p>
        <p class="text">
          (주)노루페인트는 (주)노루페인트
          <em class="is-highlight">페인트 프로</em> 홈페이지를 통하여 다음과
          같은 업무를 수행합니다.
        </p>
        <ul class="list">
          <li>
            ⅰ) 대리점 회원에 대한 도료서비스 관련 제반 정보의 제공 및 제품 주문
          </li>
          <li>ⅱ) 기타 (주)노루페인트가 정하는 업무</li>
        </ul>
        <p class="text">제13조 &lt;홈페이지 서비스의 중단&gt;</p>
        <ul class="list">
          <li>
            ① (주)노루페인트는 컴퓨터 등 정보통신설비의 점검, 보수, 교체 및
            고장, 통신두절 등의 사유가 발생한 경우에는 홈페이지 서비스의 제공을
            일시적으로 중단할 수 있습니다.
          </li>
          <li>
            ② 본 조 제①항의 사유로 홈페이지 서비스를 중단하고자 할 경우
            (주)노루페인트
            <em class="is-highlight">페인트 프로</em> 홈페이지에 게시 또는 회원
            e-mail 주소로 그 내용을 발송하는 방법으로 회원에게 홈페이지 서비스
            중단 사실을 알려드립니다.
          </li>
          <li>
            ③ (주)노루페인트의 고의 또는 과실에 기인한 홈페이지 서비스의 부당한
            중단 및 시스템 장애로 회원이 손해를 입은 경우, (주)노루페인트는
            통상적으로 예상 가능한 범위 내에서 동 손해를 배상합니다.
          </li>
        </ul>
        <p class="text">제14조 &lt;회원ID 및 Password&gt;</p>
        <ul class="list">
          <li>
            ① 홈페이지 서비스를 이용하고자 하는 회원은 (주)노루페인트가 정하는
            바에 따라 Password를 등록하여야 합니다.
          </li>
          <li>
            ② 회원ID와 Password에 관한 관리책임은 회원 본인에게 있으므로 회원은
            자신의 ID 및 Password를 제3자에게 알려주거나 이용하게 해서는
            안됩니다.
          </li>
          <li>
            ③ 회원이 자신의 ID 또는 Password를 도난 당하거나 제3자가 사용하고
            있음을 인지한 경우에는 즉시 (주)노루페인트에 통보하고
            (주)노루페인트의 안내가 있는 경우에는 그에 따라야 합니다.
          </li>
        </ul>
        <p class="text">제15조 &lt;재화 용역의 구매&gt;</p>
        <ul class="list">
          <li>
            ① 회원은 아래와 같은 절차에 따라 (주)노루페인트 페인트 프로
            홈페이지를 통하여 재화 또는 용역을 구매할 수 있습니다.
            <ul class="child-list">
              <li>ⅰ) 성명, 주소, 전화번호 입력</li>
              <li>ⅱ) 재화 또는 용역의 선택</li>
              <li>ⅲ) 결제방법의 선택</li>
              <li>ⅳ) 기타 (주)노루페인트가 별도로 정하는 절차</li>
            </ul>
          </li>
          <li>
            ② (주)노루페인트는 회원이 원하지 않을 경우 영리목적의 광고성
            전자우편을 발송하지 않으며, 재화나 용역에 대하여 「표시,광고의
            공정화에 관한 법률」 제3조 소정의 부당한 표시, 광고행위를 하지
            않습니다.
          </li>
          <li>
            ③ 회원이 자신의 ID 또는 Password를 도난 당하거나 제3자가 사용하고
            있음을 인지한 경우에는 즉시 (주)노루페인트에 통보하고
            (주)노루페인트의 안내가 있는 경우에는 그에 따라야 합니다.
          </li>
        </ul>
        <p class="text">제16조 &lt;재화 용역의 구매&gt;</p>
        <ul class="list">
          <li>
            ① 회원이 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각 호의
            하나 또는 그 이상을 결합하여 할 수 있습니다.
            <ul class="child-list">
              <li>ⅰ) 계좌이체</li>
              <li>ⅱ) 재화 또는 용역의 선택</li>
              <li>ⅱ) 신용카드결제</li>
              <li>ⅲ) 온라인무통장입금</li>
            </ul>
          </li>
          <li>
            ② 전항의 규정에도 불구하고, (주)노루페인트는 공급되는 재화 또는
            용역의 성격에 따라 대금지급방법을 한정 할 수 있으며, 이러한 경우에는
            회원이 구매신청을 하기 전에 확인할 수 있도록 사전 고지합니다.
          </li>
        </ul>
        <p class="text">제17조 &lt;수신확인통지, 구매신청 변경 및 취소&gt;</p>
        <ul class="list">
          <li>
            ① (주)노루페인트는 회원으로부터 재화 또는 용역에 대한 구매신청을
            받은 경우 당해 회원에게 구매가 성공적으로 완료되었다는 메시지(이하
            "구매완료 메시지")를 보여주며 이러한 구매완료 메시지를 회원에게
            보여줌으로써 당해 재화 또는 용역에 대한 구매계약이 성립합니다.
          </li>
          <li>
            ② 회원이 구매신청 변경 또는 취소를 하고자 할 경우에는 구매완료
            메시지를 확인하는 즉시 (주)노루페인트에 구매신청 변경 또는 취소를
            요청할 수 있습니다. 단, (주)노루페인트가 지정하는 일부 재화 또는
            용역의 경우에는 구매신청 변경 또는 취소가 제한될 수 있습니다.
          </li>
        </ul>
        <p class="text">제18조 &lt;배송&gt;</p>
        <p class="text">
          (주)노루페인트는 회원이 구매한 재화에 대해 배송수단, 수단별 배송비용,
          수단별 배송기간 등을 회원에게 알려드립니다.
        </p>
        <p class="text">제19조 &lt;환급, 반품 및 교환&gt;</p>
        <ul class="list">
          <li>
            ① (주)노루페인트는 회원이 구매 신청한 재화 또는 용역을 품절 등의
            사유로 제공 할 수 없을 경우 지체 없이 그 사유를 당해 회원에게
            통지하고, 회원의 의사에 따라 그 통지일로부터 3일 이내에 계약해제 및
            환급절차를 취합니다.
          </li>
          <li>
            ② 다음 각 호의 경우 회원은 재화를 인도 받거나 용역을 제공 받은
            날부터 20일 이내에 환급, 반품 또는 교환 청구를 할 수 있습니다.
            <ul class="child-list">
              <li>
                ⅰ) 배송된 재화가 주문내용과 상이하거나 (주)노루페인트가 제공한
                정보와 상이할 경우
              </li>
              <li>ⅱ) 배송된 재화가 파손, 손상되었거나 오염되었을 경우</li>
              <li>
                ⅲ) 재화의 인도 또는 용역의 제공이 광고에 표시된 재화의 인도시기
                또는 용역의 제공시기 보다 늦어진 경우
              </li>
              <li>
                ⅳ) 방문판매 등에 관한 법률 제18조에 의하여 광고에 표시하여야 할
                사항을 표시하지 아니한 상태에서 회원의 청약이 이루어진 경우
              </li>
            </ul>
          </li>
        </ul>
        <p class="text">제20조 &lt;회원의 의무&gt;</p>
        <p class="text">
          회원은 홈페이지 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는
          안됩니다.
        </p>
        <ul class="list">
          <li>
            ⅰ) 홈페이지 서비스 이용 관련 제반 신청행위 또는 변경 행위 시
            허위내용 기재행위
          </li>
          <li>ⅱ) 홈페이지에 게시된 각종 정보의 무단 변경, 삭제 등 훼손 행위</li>
          <li>
            ⅲ) (주)노루페인트가 허용한 정보 이외의 다른 정보(컴퓨터 프로그램 및
            광고 등)를 송신하거나 게시하는 행위
          </li>
          <li>
            ⅳ) (주)노루페인트 기타 제3자의 저작권 등 지적재산권에 대한 침해 행위
          </li>
          <li>
            ⅴ) (주)노루페인트 기타 제3자의 명예를 손상시키거나 업무를 방해하는
            행위
          </li>
          <li>
            ⅵ) 외설 또는 폭력적인 정보(메시지, 화상, 음성 등), 기타 공서양속에
            반하는 정보를 홈페이지에 공개하거나 게시하는 행위
          </li>
        </ul>
        <p class="text">제21조 &lt;WEB Site 연결과 (주)노루페인트의 책임&gt;</p>
        <p class="text">
          (주)노루페인트
          <em class="is-highlight">페인트 프로</em> 홈페이지와 다른 WEB Site가
          각종 링크(예: 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)등의
          방식으로 연결된 경우, (주)노루페인트는 회원과 당해 WEB Site가
          독자적으로 행하는 일체의 거래에 대해서 어떠한 책임도 지지 않습니다.
        </p>
        <p class="text">제22조 &lt;저작권의 귀속 및 이용제한&gt;</p>
        <ul class="list">
          <li>
            ① (주)노루페인트가 작성한 저작물에 대한 저작권 기타 지적재산권은
            (주)노루페인트에 귀속합니다.
          </li>
          <li>
            ② 회원은 (주)<em class="is-highlight">노루페인트 페인트 프로를</em>
            이용함으로써 얻은 정보를 (주)노루페인트의 사전 승낙 없이 복제, 송신,
            출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나
            제3자에게 이용하게 하여서는 안됩니다.
          </li>
        </ul>
        <strong class="subject"
          >제 6 장 (주)노루페인트 페인트 프로 홈페이지</strong
        >
        <p class="text">제23조 &lt;준거법 및 합의관할&gt;</p>
        <ul class="list">
          <li>
            ① 본 약관에서 정하지 않은 사항과 본 약관의 해석에 관하여는
            대한민국법 및 상관례에 따릅니다.
          </li>
          <li>
            ② 본 약관과 관련한 제반 분쟁 및 소송은 서울지방법원 또는
            민사소송법상의 관할 법원을 제1심 관할법원으로 합니다.
          </li>
        </ul>
        <p class="text">부칙</p>
        <p class="text is-highlight">
          본 약관은 2025년 04월 1일부터 시행합니다.
        </p>
      </div>
      <!-- // [20241206] 약관수정 -->
    </div>
  </div>
</template>

<script setup></script>
